import styled from '@emotion/styled';
import { mq } from './Responsive';
import { gray700 } from '../color';

export const StyledHeader = styled.header`
  background-color: ${gray700};
  display: flex;
  flex-direction: column;
  padding: 1rem;
  align-items: center;
  text-align: center;

  ${mq[1]} {
    text-align: center;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 2rem;
  }
`;
